import {FormioBase} from "./formiobase";

export class MyContent extends FormioBase {
  public inputType = "mycontent";
  public title = "MyContent";
  public html = "<span>My - Content</span>";
  public icon = "fab fa-html5";
  public schema: any = {
    title: "MyContent",
    components: [{
      type: "content",
      inputType: "mycontent",
      key: "mycontent1",
      input: false,
      label: "MyContent",
      content: this.html,
      customClass: "alert alert-danger ds-mycontent",
    }],
  };
}
